<div class="table-responsive mt-3">
    <table class="table table-hover mb-none">
        <thead>
            <tr>
                <th width="10%">#</th>
                <th width="80%">Lender</th>
                <th width="10%">Has Access</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let lender of lendersList;index as i">
                <td>{{i+1}}</td>
                <td>{{lender.lenderName}}</td>
                <td>
                    <ng-container *ngIf="!isEditMode">
                        <span *ngIf="lender.hasAccess"><i class="fas fa-check"></i></span>
                        <span *ngIf="!lender.hasAccess"><i class="fas fa-times"></i></span>
                    </ng-container>
                    <ng-container *ngIf="isEditMode">
                        <button type="button" class="btn btn-text bg-transparent p-0" (click)="toggleHasAccess(lender)">
                            <span class="text-sm fas fa-toggle-on text-primary" *ngIf="lender.hasAccess"></span>
                            <span class="text-sm fas fa-toggle-off text-muted" *ngIf="!lender.hasAccess"></span>
                        </button>
                    </ng-container>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<footer class="panel-footer mt-3">
    <div class="row">
        <div class="col-sm-12 text-end">
            <button class="btn btn-primary" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Edit</button>
            <button class="btn btn-outline-primary mr-1" type="button" (click)="toggleEditMode()"
                *ngIf="isEditMode">Cancel</button>
        </div>
    </div>
</footer>
